import React from 'react';

type Props = {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  viewBox?: string;
};

// Inline content-feed icon so the color can be controlled (an external <img> can't be
// tinted). Pass any color; defaults to `currentColor` so it inherits text color.
const ContentFeedIcon = ({ size = 22, color = 'currentColor', strokeWidth = 2.4, viewBox = '0 0 34 34' }: Props) => (
  <svg width={size} height={size} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3125 3.2002C17.3403 3.20021 21.4248 7.28465 21.4248 12.3125C21.4248 17.3403 17.3403 21.4248 12.3125 21.4248C7.28465 21.4248 3.20021 17.3403 3.2002 12.3125C3.2002 7.28464 7.28464 3.2002 12.3125 3.2002ZM12.127 8.06836C10.5511 7.30653 8.68457 8.448 8.68457 10.2314V14.3936C8.68457 16.2345 10.6734 17.391 12.2783 16.4766L12.2852 16.4736L14.085 15.4326L15.8828 14.3916L15.8838 14.3926C17.4814 13.4715 17.4814 11.1535 15.8838 10.2324H15.8828L14.085 9.19238L12.2852 8.15137L12.2783 8.14844L12.127 8.06836Z"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M29.1875 14.4502C30.0716 14.4502 30.7998 15.1784 30.7998 16.0625V29.1875C30.7998 29.7689 30.4748 30.2882 29.9795 30.5664C29.9712 30.5706 29.9619 30.5766 29.9512 30.582C29.9059 30.6048 29.8401 30.6372 29.7598 30.6768C29.5977 30.7565 29.3788 30.8616 29.1504 30.9658C28.9188 31.0715 28.6921 31.1695 28.5088 31.2383C28.4289 31.2683 28.3689 31.2877 28.3281 31.2998H17.7686C17.7935 31.2998 17.6413 31.2827 17.2383 31.1523C16.8933 31.0408 16.4845 30.8876 16.083 30.7275C15.6844 30.5686 15.3069 30.4085 15.0283 30.2881C14.9436 30.2515 14.8683 30.2184 14.8047 30.1904C14.5798 29.9081 14.4502 29.5619 14.4502 29.1875V25.5264C20.1228 24.6163 24.6163 20.1228 25.5264 14.4502H29.1875Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
    <rect x="20" y="26" width="8" height="2" rx="1" fill={color} />
    <rect x="24.5" y="22" width="3.5" height="2" rx="1" fill={color} />
  </svg>
);

export default ContentFeedIcon;
